import { HistoryEvent, HistoryEventParameters } from '@api/types';
import { nameStartsWith } from '@react/constants/historyEvent/utils';

class SnapchatCredentialsUpdater {
  check(event: HistoryEvent): boolean {
    return (
      nameStartsWith(event, 'dashboard:snapchat_credential') ||
      nameStartsWith(event, 'oauth_service:snapchat_credential')
    );
  }

  updateParams(params: HistoryEventParameters): void {
    params.credentialName = params.credential_name;
  }
}

export const snapchatCredentialsUpdater = new SnapchatCredentialsUpdater();
